import 'whatwg-fetch';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { setOptions, overrideComponent } from '@sheerid/jslib';
import './index.css';
import App from './App';
import { StepSuccessComponent } from './components/StepSuccessComponent';
import { StepDocUploadComponent } from './components/StepDocUploadComponent';
import { StepPendingComponent } from './components/StepPendingComponent';
import { StepFirstResponderPersonalInfoComponent } from './components/StepFirstResponderPersonalInfoComponent';

setOptions({
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    messagesWithLocale: {
        'en-US' : {
            step: {
                personalInfo: {
                    title: 'Verify your details',
                    subtitle: 'Complete the form below to confirm your eligibilty.',
                },
                docUpload: {
                    submitButtonLabel: 'SUBMIT FOR REVIEW',
                    title: 'Upload Documentation',
                    clickHere: 'click here',
                    subtitle: 'To complete verification, please submit any document that clearly shows your name and your first responder status.',
                    docDisplay: 'Important - Your document must display the following:',
                    uploadDocFullName: 'Your full name',
                    uploadDocOrg: 'Your organization',
                    uploadDocAffiliation: 'Your affiliation',
                    uploadDocIfName: 'If your name or organization are not correct, please ',
                    uploadDocAreNotCorrect: ' to enter your information again.',
                    uploadDocAcceptableDocs: 'Examples of acceptable documents are:',
                    uploadDocIdCard: 'ID Card',
                    uploadDocPayStub: 'Pay stub dated within 60 days',
                    uploadDocOfficialDoc: 'Any official document that clearly shows your first/last name, current date, and status as a First Responder',
                    uploadDocAcceptableFormats: 'Acceptable formats are: ',
                    uploadDocFormatTypes: '.bmp, .gif, .jpg, .png, or .pdf.',
                    fileInstructions: 'Choose file',
                    uploadDocNoFileSelected: 'No file selected.',
                    addFile: "Add file",
                    uploadDocDocScan: "NOTE: If your document scan is too fuzzy to read, does not show your full and legal name or shows a name different from the one you are verifying this offer under, you will not be able to finalize the verification process. Please do not include any confidential information on the uploaded document, such as social security numbers or banking details. Please be sure any sensitive information is blacked out before you upload your document.",
                }
            },
            dateTime: {
                january: 'Jan',
                february: 'Feb',
                march: 'Mar',
                april: 'Apr',
                may: 'May',
                june: 'Jun',
                july: 'Jul',
                august: 'Aug',
                september: 'Sep',
                october: 'Oct',
                november: 'Nov',
                december: 'Dec',
            },
            status: 'CURRENT STATUS',
            organization: 'ORGANIZATION NAME',
            firstName: 'FIRST NAME',
            lastName: 'LAST NAME',
            emailAddress: 'EMAIL ADDRESS',
            birthDate: 'DATE OF BIRTH',
            postalCode: 'POSTAL CODE',
            verifyMyFirstResponderStatus: 'SUBMIT FOR REVIEW',
            firstResponderInfoShared: 'Information entered into this web form will be used for verification purposes. <br> The information will be shared with Purple.',
        }
    }
});

// @ts-ignore
overrideComponent('StepFirstResponderPersonalInfoComponent', StepFirstResponderPersonalInfoComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
overrideComponent('StepPendingComponent', StepPendingComponent);

ReactDOM.render(<App />, document.getElementById('root'));
